module.exports = __webpack_public_path__ + "img/vue.346e12ee.svg";